import styles from './SubTabsPage.module.scss';
import { PropsWithChildren, ReactNode } from 'react';

interface SubTabsPageProps {
  tabs?: ReactNode;
}

/**
 * The elements in the children prop are rendered at the same DOM tree level as the tabs.
 * This means that any react-router Outlet elements can be styled to sit in the same grid as the tabs.
 */
export const SubTabsPage = ({ tabs, children }: PropsWithChildren<SubTabsPageProps>) => {
  return (
    <div className={styles.subTabsPage}>
      <div className={styles.subTabsPage__tabs}>{tabs}</div>
      {children}
    </div>
  );
};

export default SubTabsPage;
